import { create } from "zustand"

const initialState = {
  hasError500: false,
  errorPath: null,
}

export const useErrorStore = create(set => ({
  errorState: initialState,
  setError: path =>
    set(state => ({
      ...state,
      hasError500: true,
      errorPath: path,
    })),
  clearError: () => set({ errorState: initialState }),
}))
